export class CustomerBillingInvoiceDetailModel {
    Id = undefined;
    InvoiceId = undefined;
    Description = undefined;
    Quantity = undefined;
    ItemPrice = undefined;
    Discount = undefined;
    InvoiceDetailType = undefined;
    PackageType = undefined;
    IsModuleCharge = false;
    Name?: string;

    constructor(data) {
        if (data) this.Initialize(data);
    }

    isComment() {
        return this.InvoiceDetailType == CustomerBillingInvoiceDetailModel.InvoiceDetailTypeComment;
    }

    Initialize(data) {
        Object.assign(this, data);
    }

    static InvoiceDetailTypeInvoiceRow = 1;
    static InvoiceDetailTypeComment = 2;
}
